import React from 'react'
import Swiper from 'react-id-swiper'

import Link from '../../Components/HeaderLink'
import Tooltip from '../../Components/Tooltip'
import Text from '../../Components/Text'

import './index.css'

const gallerySwiperParams = {
	slidesPerView: 1,
	pagination: {
		el: '.swiper-pagination.swiper-pagination-grey',
		type: 'bullets',
		clickable: true
	}
};

const ContainerProduct = (({about_no_price,btnBack,title,subtitle,price_str,price,no_price,slider,infos,infos_text,tech_details,btnAsk,contacts})=>(
	<div>
		<div className="product__header">
			

			{
				contacts && contacts ? (<div className="contacts">
					{
						contacts.map((link,id)=>( 
							<Link url={link.link.url} text={link.link.caption} target={link.link.target} icon={link.icon} key={id} />		
						))
					}
				</div>):''
			}
			<Link url={btnBack.url} text={btnBack.caption} target={btnBack.target} icon="chevron-left" className="btn btn--back" />
		</div>
		<div className="row">
			<div className="col">
				<div className="container__slider">
					<Swiper {...gallerySwiperParams}>
						{
							slider && slider.map((slide,id)=>(
								<div className="slide" key={id}>
									<div className="img">
										<img src={slide.imgUrl} alt=""/>
									</div>
								</div>
							))
						}
					</Swiper>
				</div>
			</div>
			<div className="col">
				<h2>{title}</h2>
				{ subtitle && subtitle !== '' ? <h3>{subtitle}</h3> : '' }
				<div className="price">{price_str} : {price && price !== '' ? <span>{price}</span> : <span>{no_price}</span>}</div>
				
				{
					infos_text && infos_text ?(
						<div>
							<Text text={infos_text} />
							{
								tech_details === null && btnAsk.url !== '' ? <div><Link url={btnAsk.url} text={btnAsk.caption} target={btnAsk.target} className="btn btn--2 btn--x-small" /></div> : ''
							}
							{
								price === '' && about_no_price !== null ? <Tooltip icon="exclamation" {...about_no_price} _className="tooltip"/> : ''
							}
						</div>
					) 
					: 
					(
						<div className="row">
							<div className="row">
							{
								infos && infos ? infos.map((info)=>(
									<div className="col">
										{info.title}<br/>
										<Text text={info.text} />
									</div>
								)): ''
							}
							</div>
							{
								tech_details === null && btnAsk.url !== '' ? <div><Link url={btnAsk.url} text={btnAsk.caption} target={btnAsk.target} className="btn btn--2 btn--x-small" /></div> : ''
							}
						</div>
					)
				}
					
			</div>
			<div className="tech_details">
				{
					tech_details && tech_details !== '' ? (
						<div>
							<Text text={tech_details} />
							{
								btnAsk && btnAsk.url !== '' ? <Link url={btnAsk.url} text={btnAsk.caption} target={btnAsk.target} className="btn btn--2 btn--x-small" /> : ''
							}
						</div>
					) : ''
				}
			</div>

						
		</div>
	</div>
))

export default ContainerProduct


// WEBPACK FOOTER //
// ./src/Containers/ContainerProduct/index.js